export default __webpack_public_path__ + "static/media/404.36d264a1.png";